export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/mute-icon.svg?a862c5724da7cdd59c1b5303fb3e9814";